// IMPORTANT: Polyfills must be imported FIRST before any other code
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Keep a minimal compatibility check, but do not log noisy debug output in production.
const hasPromise = typeof Promise !== 'undefined';
const hasSymbol = typeof Symbol !== 'undefined';

if (!hasPromise || !hasSymbol) {
  const rootEl = document.getElementById("root");
  if (rootEl) {
    // Create elements safely without innerHTML
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'padding:20px;background:#fee;color:#c00;font-family:Arial;';
    
    const heading = document.createElement('h2');
    heading.textContent = 'Browser Not Supported';
    
    const paragraph = document.createElement('p');
    paragraph.textContent = 'Your browser is too old. Please use a modern browser.';
    
    errorDiv.appendChild(heading);
    errorDiv.appendChild(paragraph);
    rootEl.appendChild(errorDiv);
  }
  throw new Error('Browser compatibility check failed');
}

try {
  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error('Root element not found');

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  const rootEl = document.getElementById("root");
  if (rootEl) {
    // Create elements safely without innerHTML
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'padding:20px;background:#fee;color:#c00;font-family:Arial;';
    
    const heading = document.createElement('h2');
    heading.textContent = 'App failed to start';
    
    const paragraph = document.createElement('p');
    paragraph.textContent = 'Please reload the page.';
    
    errorDiv.appendChild(heading);
    errorDiv.appendChild(paragraph);
    rootEl.appendChild(errorDiv);
  }
}
